import { Instance } from 'mobx-state-tree'
import { GameStatsModelBase } from './GameStatsModel.base'

/* The TypeScript type of an instance of GameStatsModel */
export interface GameStatsModelType extends Instance<typeof GameStatsModel.Type> {}

/* A graphql query fragment builders for GameStatsModel */
export { selectFromGameStats, gameStatsModelPrimitives, GameStatsModelSelector } from './GameStatsModel.base'

/**
 * GameStatsModel
 */
export const GameStatsModel = GameStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
